    <!-- Notifications toggle -->
    <button class="user-button" mat-icon-button (click)="openPanel()" #notificationsOrigin>
        <mat-icon class="s-20" *ngIf="unreadCount > 0">notifications_active</mat-icon>
        <mat-icon class="s-20" *ngIf="unreadCount == 0">notifications</mat-icon>
        <span [ngClass]="{'has-notification': unreadCount > 0}"></span>
    </button>
    
    <!-- Notifications panel — ORCA-1945: painel no padrão do design system (NotificationItem):
         itens com altura livre (a mensagem aparece inteira) e ações visíveis no foco -->
    <ng-template #notificationsPanel>
        <section class="oa-notif-panel" @fadeInOut role="dialog" aria-label="Notificações">
            <header class="oa-notif-panel__head">
                <h2 class="oa-notif-panel__title">
                    Notificações
                    <span *ngIf="unreadCount" class="oa-notif-panel__count">{{ unreadCount }}</span>
                </h2>
                <button *ngIf="unreadCount" type="button" class="oa-notif-panel__link" (click)="markAllAsRead()">
                    Marcar todas como lidas
                </button>
                <button type="button" class="oa-icon-btn oa-notif-panel__close" (click)="closePanel()" aria-label="Fechar notificações">
                    <mat-icon>close</mat-icon>
                </button>
            </header>

            <div class="oa-notif-panel__list" role="list">
                <div *ngFor="let notification of notifications" role="listitem" class="oa-notif oa-notif-row"
                    [class.oa-notif--unread]="!notification.readAt"
                    [class.is-link]="notification.data.link || notification.data.useRouter">
                    <button type="button" class="oa-notif-row__main" (click)="redirectTo(notification)"
                        [attr.aria-label]="notification.data.title">
                        <span *ngIf="notification.data.icon && !notification.data.image" aria-hidden="true"
                            class="oa-notif__icon oa-notif__icon--{{ toneFor(notification) }}">
                            <mat-icon>{{ notification?.data?.icon }}</mat-icon>
                        </span>
                        <ngx-avatar *ngIf="!notification.data.icon || notification.data.image" class="oa-notif-row__avatar"
                            [round]="true" size="32" [name]="notification.data.title" [src]="notification.data.image"></ngx-avatar>

                        <span class="oa-notif__text">
                            <span *ngIf="notification.data.title" class="oa-notif-row__title" [innerHTML]="notification.data.title"></span>
                            <!-- texto completo: antes a altura fixa cortava a mensagem -->
                            <span *ngIf="notification.data.description" class="oa-notif-row__desc"
                                [innerHTML]="notification.data.description"></span>
                            <b *ngIf="notification.data.detail">{{ notification.data.detail }}</b>
                            <small>{{ notification.criadoEm }}</small>
                        </span>
                    </button>

                    <div class="oa-notif-row__actions">
                        <button type="button" class="oa-notif-row__dot-btn" (click)="toggleRead(notification)"
                            [matTooltip]="!notification.readAt ? 'Marcar como lida' : 'Marcar como não lida'"
                            [attr.aria-label]="!notification.readAt ? 'Marcar como lida' : 'Marcar como não lida'">
                            <span class="oa-notif-row__dot" [class.is-unread]="!notification.readAt"></span>
                        </button>
                        <button type="button" class="oa-icon-btn oa-icon-btn--sm oa-notif-row__delete" (click)="delete(notification)"
                            matTooltip="Excluir" aria-label="Excluir notificação">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>

                    <div *ngIf="notification.data.external_url" class="oa-notif-row__more">
                        <a [href]="notification.data.external_url" target="_blank" rel="noopener"
                            class="oa-btn oa-btn--secondary oa-btn--sm">{{ notification.data.external_url_label || 'Abrir' }}</a>
                    </div>
                </div>

                <div *ngIf="!notifications || !notifications.length" class="oa-notif-panel__empty">
                    <img src="/assets/svg/orca-32.svg" alt="" width="56" height="56">
                    <p>Você não possui nenhuma notificação no momento.</p>
                </div>
            </div>
        </section>
    </ng-template>
